import styled, { keyframes, css } from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const pulseAnimation = keyframes`
  0% {
    opacity: 0.3;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 0.3;
  }
`

export const Container = styled.div<{ isFetching?: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-row-gap: 15px;
  grid-column-gap: 15px;
  ${bp('lg')`
    grid-template-columns: 1fr 1fr;
  `}

  ${bp('sm')`
    grid-template-columns: 1fr;
  `}

  ${props => props.isFetching && css`
    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: wait;
      background: rgba(255, 255, 255, 0.7);
      animation: ${pulseAnimation} 2s infinite;
    }
  `}

  img {
    display: block;
    width: 100%;
  }

  a {
    color: ${props => props.theme.palette.general.strong};
    text-decoration: none;
  }
`

export const NoItems = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 30px auto;
  padding: 40px 20px;
  color: ${props => props.theme.palette.general.grey};
  font: ${font('default', 'normal', '18px/1')};
  min-height: 300px;

  button {
    cursor: pointer;
    font: ${font('default', 'normal', '18px/1')};
    color: ${props => props.theme.palette.general.strong};
    margin: 0;
    padding: 7px;
    border: none;
    background: none;
  }
`
